const CACHE_KEY = "bookingDataCache";
const CACHE_TTL = 1000 * 60 * 5; // 5 minutes

export const saveBookingCache = (data) => {
  const payload = {
    timestamp: Date.now(),
    data,
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
};

export const getBookingCache = () => {
  const cached = localStorage.getItem(CACHE_KEY);
  if (!cached) return null;

  try {
    const parsed = JSON.parse(cached);
    const isExpired = Date.now() - parsed.timestamp > CACHE_TTL;
    return isExpired ? null : parsed.data;
  } catch (e) {
    console.error("Error reading cache:", e);
    return null;
  }
};

export const clearBookingCache = () => {
  localStorage.removeItem(CACHE_KEY);
};

export const saveVehicleCache = (vehicles) =>
  localStorage.setItem("vehicleCache", JSON.stringify(vehicles));

export const getVehicleCache = () => {
  try {
    return JSON.parse(localStorage.getItem("vehicleCache")) || [];
  } catch {
    return [];
  }
};
